import type { FC, ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { DatesProvider } from '@mantine/dates';
import dayjs from 'dayjs';
import i18next from 'i18next';
import 'dayjs/locale/ru';
import 'dayjs/locale/kk';

type ILocalContextProps = {
  //
};

export const LocalContext = createContext<ILocalContextProps>({});

export const LocalContextProvider: FC<{ children?: ReactNode }> = (props) => {
  const locale = i18next.language == 'kz' ? 'kk' : 'ru';

  useMemo(() => {
    document.documentElement.lang = locale;
    dayjs.locale(locale);
  }, [locale]);

  return (
    <DatesProvider settings={{ locale }}>
      <LocalContext.Provider value={{}}>{props.children}</LocalContext.Provider>
    </DatesProvider>
  );
};

export const useLocalContext = () => {
  const localContext = useContext(LocalContext);

  if (typeof localContext === 'undefined') {
    throw new Error('useLocalContext must be used within a LocalContextProvider');
  }

  return localContext;
};
